import React, { FormEvent, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";

import CheckoutProgress from "../../components/CheckoutProgress";
import { Checkbox, Container, Form, Grid } from "semantic-ui-react";
import PrimaryButton from "../../components/Button/PrimaryButton";
import { cartItemsSelector } from "../../utils/selectors";
import styles from "./Payment.module.scss";
import { savePaymentMethod } from "../../actions/cartActions";

const Payment = () => {
  const navigate = useNavigate();
  const cart = useSelector((state) => cartItemsSelector(state));

  const [paymentMethod, setPaymentMethod] = useState("PayPal");

  const dispatch = useDispatch();
  const intl = useIntl();

  useEffect(() => {
    if (!cart) {
      navigate("/cart");
    }
  }, [cart, navigate]);

  const submitHandler = (e: FormEvent) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate(`/order?paymentMethod=${paymentMethod}`);
  };

  return (
    <Container>
      <Grid centered padded>
        <Grid.Column>
          <CheckoutProgress active={"payment"} />
          <h1>
            <FormattedMessage
              id="payment.method.title"
              defaultMessage="Payment Method"
            />
          </h1>
          <Form onSubmit={submitHandler}>
            <Form.Group widths={8}>
              <Checkbox
                type="radio"
                label={intl.formatMessage({
                  id: "payment.method.paypalLabel",
                  defaultMessage: "PayPal or Credit Card",
                })}
                id="PayPal"
                name="paymentMethod"
                value="PayPal"
                className={styles.checkbox}
                checked
                onChange={(e: any) => setPaymentMethod(e.target.value)}
              />

              <Checkbox
                type="radio"
                label={intl.formatMessage({
                  id: "payment.method.stripeLabel",
                  defaultMessage: "Stripe",
                })}
                id="Stripe"
                name="paymentMethod"
                value="Stripe"
                className={styles.checkbox}
                onChange={(e: any) => setPaymentMethod(e.target.value)}
              />
            </Form.Group>
            <Grid centered>
              <Grid.Column mobile={12} tablet={8} computer={6}>
                <PrimaryButton>
                  <FormattedMessage
                    id="payment.continue"
                    defaultMessage="Continue"
                  />
                </PrimaryButton>
              </Grid.Column>
            </Grid>
          </Form>
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export default Payment;
